import { getLogger } from "@expert/logging";

import { type CctsContact, type Contact, getContactPartner } from "@/shared-types";
import { getSharedApiClient } from "@/shared-utils";

const logger = getLogger({
    module: "getContactDetails",
});

export const getContacts = async (): Promise<Contact[]> => {
    try {
        const { contacts, transferOptions } = await getSharedApiClient()
            .extend(({ prefix }) => ({ prefix: `${prefix}/api/vdn-contacts/v1` }))
            .get("contacts")
            .json<{ contacts: CctsContact[]; transferOptions: Contact[] }>();

        // Transform the contacts by adding default values for group and isInternal
        const normalizedContacts: Contact[] = contacts.map(
            (contact: CctsContact) =>
                ({
                    name: contact.friendlyName,
                    number: String(contact.destination),
                    vdn: contact.vdn,
                    group: contact.group ?? "Unlisted", // Default group for vdn's being fetched from contacts api
                    partner: getContactPartner(contact),
                    isInternal: true,
                }) as Contact,
        );

        // Combine TRANSFER_OPTIONS with unlisted contacts
        const combinedContacts: Contact[] = [...transferOptions, ...normalizedContacts];
        return combinedContacts;
    } catch (error: unknown) {
        logger.warn({ error }, "getContacts API call failed with exception. Only known transfer options returned");
        return [];
    }
};
